import React from 'react'
import { ContentBlock } from '../../../components/Layout/ContentBlock/ContentBlock'

export function OrdersNotFound() {
  return <ContentBlock>Заказы не найдены</ContentBlock>
}
